import React from 'react';
import { Firestore } from 'firebase/firestore';
import { ClubSignup } from '../ClubSignup';

/**
 * "Order TrueNooch direct" landing page — join the club, become a founding
 * regular.
 *
 * The pizza-party shot (truenooch-home-hero-v3.webp) lives HERE now, not on the
 * home hero: you walk in on the warm evening the brand is really about — good
 * people, a wood-fired pizza, a Round sliced onto the board — and THEN you join.
 * That's the deliberate fix for the page reading like a velvet rope: the club is
 * a table you're invited to, not a list you have to qualify for. First-person,
 * because this is the page where you actually meet Jarvis.
 *
 * Feature-flagged in the nav (FEATURES.club); the route always renders so it can
 * be previewed by URL before launch. background-image is set inline (same reason
 * as Hero.tsx): CRA's css-loader can't resolve absolute /images/... paths from
 * src/, so the URL is built from process.env.PUBLIC_URL at runtime.
 */
export function ClubPage({ db }: { db: Firestore | null }) {
  const partyBg = `url(${process.env.PUBLIC_URL}/images/brand/truenooch-home-hero-v3.webp)`;
  return (
    <>
      <div className="club-hero" style={{ backgroundImage: partyBg }}>
        <div className="club-hero-content">
          <div className="club-hero-eyebrow">Order Direct · Colorado</div>
          <h1>Come to the table.</h1>
          <p className="club-hero-sub">
            This whole thing really lives on nights like this — good people, a wood-fired
            pizza, a round of TrueNooch sliced onto the board. The club is just how you get a standing
            seat at it.
          </p>
        </div>
      </div>

      <section className="section fade-in">
        <h2>Join the club.<br />Be a founding regular.</h2>
        <p>
          I make TrueNooch by hand, in small batches, here in Colorado — and I sell it
          straight to the people who actually eat it. Club members order direct, and the
          first ones in become <em>founding regulars</em>: the table this whole thing is
          built on.
        </p>
        <p className="club-foreshadow">
          A seat kept for you, and the good stuff coming out of the kitchen first.
        </p>
        <div className="club-perks">
          <div className="club-perk">
            <h4>First dibs</h4>
            <p>Batches are small. You get first pick, every time, before anyone else.</p>
          </div>
          <div className="club-perk">
            <h4>A seat at the table</h4>
            <p>Founding regulars get a real say in what we make — and a proper welcome, from me.</p>
          </div>
          <div className="club-perk">
            <h4>Never run out</h4>
            <p>Tell me your rhythm and I’ll keep TrueNooch there for you when you reach for it.</p>
          </div>
        </div>
      </section>
      <ClubSignup db={db} />
    </>
  );
}
